import { ref } from "vue";
import { useStore } from "vuex";

export function useRetryAnalysis(analysisType) {
  const store = useStore();
  const retrying = ref(false);

  async function retryAnalysis(declarationId, emit) {
    retrying.value = true;
    try {
      const response = await store.dispatch("claimDeclarations/retryAiAnalysis", {
        declarationId,
        analysisType,
      });
      if (response?.success) {
        emit("retry-success");
        emit("close");
      }
    } finally {
      retrying.value = false;
    }
  }

  return { retrying, retryAnalysis };
}
